function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.72 1.49L16 .27V0h-4.42L8.43 7.85 4.84 0H.2v.27l1.49 1.79a.66.66 0 01.21.52v7.06a.82.82 0 01-.22.7L0 12.38v.26h4.76v-.27l-1.68-2a.86.86 0 01-.23-.7V3.54L7 12.64h.49l3.59-9.1v7.25c0 .19 0 .23-.12.36L9.7 12.4v.27H16v-.27l-1.25-1.22a.37.37 0 01-.14-.36v-9a.37.37 0 01.11-.33z"
});

function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16 12.67"
  }, props), _ref);
}

export default SvgMedium;